import React from "react";
import { createPortal } from "react-dom";
import { MdClose, MdVideocam } from "react-icons/md";

const VideoJsPlayerLazy = React.lazy(() => import("components/ui/PlyrVideoPlayer"));

export function ChatVideoPreviewModal({
  url,
  name,
  mimeType,
  isArabic,
  onClose,
}: {
  url: string;
  name: string | null;
  mimeType?: string | null;
  isArabic: boolean;
  onClose: () => void;
}) {
  React.useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  return createPortal(
    <div
      className="fixed inset-0 z-[1200] flex items-center justify-center bg-black/70 p-4"
      onClick={onClose}
    >
      <div
        className="flex w-full max-w-4xl flex-col overflow-hidden rounded-2xl bg-white shadow-2xl dark:bg-navy-800"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
      >
        <div className="flex items-center justify-between gap-2 border-b border-gray-100 px-4 py-3 dark:border-white/10">
          <div className="flex min-w-0 items-center gap-2">
            <MdVideocam className="h-5 w-5 shrink-0 text-brand-500" />
            <span className="truncate text-sm font-semibold text-gray-800 dark:text-white">
              {name ?? (isArabic ? "فيديو" : "Video")}
            </span>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="rounded-lg p-1.5 text-gray-500 hover:bg-gray-100 dark:hover:bg-white/10"
            aria-label={isArabic ? "إغلاق" : "Close"}
          >
            <MdClose className="h-5 w-5" />
          </button>
        </div>
        <div className="bg-black p-2">
          <React.Suspense
            fallback={
              <div className="flex aspect-video w-full items-center justify-center">
                <span className="text-sm text-white/70">…</span>
              </div>
            }
          >
            <VideoJsPlayerLazy
              key={url}
              src={url}
              mimeType={mimeType ?? undefined}
              className="max-h-[min(80vh,720px)]"
              brandName="Easyfollow"
              brandInitial="E"
            />
          </React.Suspense>
        </div>
      </div>
    </div>,
    document.body
  );
}
